import DropDown, { ContextMenuItem } from "@/src/components/ui-kit/drop-down";
import { GENDER_OPTIONS } from "@/src/constants/user-profile.constant";
import { useTheme } from "@/src/styles/theme-provider";
import { ArrowDown2 } from "iconsax-react-nativejs";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";

type GenderPickerProps = Readonly<{
  value: string;
  canEdit: boolean;
  onChange: (value: string) => void;
}>;

const GenderPicker = ({ value, canEdit, onChange }: GenderPickerProps) => {
  const { t } = useTranslation();
  const { themeVars } = useTheme();

  const items: ContextMenuItem[] = GENDER_OPTIONS.map((gender) => ({
    label: gender,
    onPress: () => onChange(gender),
  }));

  return (
    <View className="flex-1 gap-1">
      <Text className="text-base text-onyx">{t("LABEL_GENDER")}</Text>
      <View className="flex-row items-center md:border md:border-ash-3 bg-ash rounded-[10px] px-3 h-[50px] gap-2">
        {canEdit ? (
          <DropDown
            items={items}
            menuWidth={150}
            trigger={
              <View className="flex-row items-center gap-2">
                <Text className="text-slate text-base">
                  {value || t("LABEL_SELECT_GENDER")}
                </Text>
                <ArrowDown2
                  size={18}
                  color={themeVars["--color-ash-2"] as string}
                />
              </View>
            }
          />
        ) : (
          <Text className="text-slate text-base flex-1">
            {value || t("LABEL_SELECT_GENDER")}
          </Text>
        )}
      </View>
    </View>
  );
};

export default GenderPicker;
